/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../Assets/fallbackimg_giftcard.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { encryptURLParam } from "../../Common/Axios/encrypt";
import pointIcon from "../../Assets/point_icon.svg";
import { ClientInfo, getImageUrl, trackEvent, useGaTrackingConfig, getRewardBaseDenomination, calculateEarning, EARNING_DISPLAY_TYPE } from "../Utility/Utility";
const TrendingGiftCards = ({ value, itemIndex }) => {
  const requestedSection = itemIndex ?? value;
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const translation = getTranslationData();
  const addSpecialData = useSelector(
    (state) => state.addSpecialReducer.getData
  );
  const categoryAllData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData
  );
  const gaTrackingConfig = useGaTrackingConfig();
  const observedSectionsRef = React.useRef(new Set());
  const sectionElementsRef = React.useRef({});
  const sectionObserverRef = React.useRef(null);
  const clientConfigReducer = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData?.[0]
  );


  const clientConfigurationData = clientConfigReducer?.clientConfig || [];

  const earnLabelConfig = clientConfigurationData?.find(
    (item) => item.configKey.toLowerCase() === "isearnlabelshowonly"
  )?.configValue;
  const isDiscountShowLabel = clientConfigurationData?.find(
    (item) => item?.configKey.toLowerCase() === "isdiscountlabeldisplay"
  )?.configValue;

  const isEarnLabelConfig = earnLabelConfig === "1" || earnLabelConfig === 1 || earnLabelConfig === "true" || earnLabelConfig === true;
  const isDiscountShowLabelConfig = isDiscountShowLabel === "1" || isDiscountShowLabel === 1 || isDiscountShowLabel === "true" || isDiscountShowLabel === true;

  // const sortedArray = useSelector(
  //   (state) => state?.allocateBrandReducer?.getAllocateBrandData
  // );

  // const productByClientData = useSelector(
  //   (state) => state.productReducer.productById?.[0]?.products
  // );

  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );

  // useEffect(() => {
  //   if (
  //     addSpecialData &&
  //     sortedArray &&
  //     productByClientData &&
  //     productDiscount
  //   ) {
  //     const filteredAddSpecialData =
  //       Array.isArray(addSpecialData) &&
  //       addSpecialData
  //         .filter((data) => data.enabled === true && data.isSpecial === false)
  //         .map((addSpecial) => {
  //           const allocatedBrands = sortedArray.filter(
  //             (brand) => brand.addSpecialId === addSpecial.id && brand.enabled
  //           );

  //           const arraySorted = Array.isArray(allocatedBrands)
  //             ? [...allocatedBrands].sort(
  //               (a, b) => a.displayOrder - b.displayOrder
  //             )
  //             : [];
  //           const products = arraySorted.map((brand) => {
  //             const product = productByClientData?.find(
  //               (product) => product.id === brand.productId
  //             );
  //             if (product) {
  //               const discount = productDiscount.find(
  //                 (discount) => discount.productId === product.id
  //               );
  //               const customerDiscount = discount && discount?.customerDiscount;
  //               return {
  //                 ...product,
  //                 customerDiscount,
  //                 priceDenomination: discount?.priceDenomination,
  //               };
  //             }
  //             return product;
  //           });
  //           const filteredArray = products.filter(
  //             (element) => element !== undefined
  //           );
  //           return {
  //             sectionName: addSpecial.sectionName,
  //             sectionDesc: addSpecial.description,
  //             buttonText: addSpecial.buttonText,
  //             displayOrder: addSpecial.displayOrder,
  //             products: filteredArray,
  //           };
  //         });

  //     Array.isArray(filteredAddSpecialData) &&
  //       filteredAddSpecialData?.sort((a, b) => a.displayOrder - b.displayOrder);
  //     setFinalData(filteredAddSpecialData);
  //     dispatch(setFilteredAddSpecial(filteredAddSpecialData));
  //   }
  // }, [
  //   addSpecialData,
  //   sortedArray,
  //   productByClientData,
  //   productDiscount,
  //   dispatch,
  // ]);
  useEffect(() => {
    if (!addSpecialData || addSpecialData.length === 0) return;
    // No need to calculate height anymore, using aspect-ratio CSS
  }, [addSpecialData]);



  const getCategoryName = (product) => {
    if (product?.categoryName) return product.categoryName;
    if (!Array.isArray(categoryAllData)) return "products";
    const category = categoryAllData.find(
      (cat) => String(cat?.id) === String(product?.categoryId)
    );
    return category?.name || "products";
  };

  const getItemUrl = (product) => {
    const categoryId = product?.categoryId?.toString();
    if (!categoryId) return window.location.href;

    const finalCategoryId =
      process.env.REACT_APP_IS_E_E === "false"
        ? categoryId
        : encryptURLParam(categoryId);

    return `${window.location.origin}/productlist?categoryId=${finalCategoryId}`;
  };

  const getHomeSections = () => {
    if (!Array.isArray(addSpecialData)) return [];

    return addSpecialData
      .filter((item) => String(item?.visibleBy)?.toUpperCase() === "HOME")
      .map((item, index) => {

        const validProducts =
          item?.products?.filter((p) => {
            const denominations = p?.clientProductDenomination || [];
            if (!denominations?.length) return false;
            const allStockOut = denominations.every((d) => d?.stockOut === true);
            return !allStockOut;
          }) || [];

        const showMoreAfter = Number(item?.showMoreGiftCard)
          ? Number(item?.showMoreGiftCard)
          : 11;

        const sortedVisibleProducts = [...validProducts]
          .sort((a, b) => a.displayOrder - b.displayOrder)
          .slice(0, showMoreAfter);

        return {
          ...item,
          _homeSectionIndex: index + 1,
          _sectionKey: String(item?.id || `section-${index}`),
          _validProducts: validProducts,
          _visibleProducts: sortedVisibleProducts,
        };
      });
  };

  const homeSections = getHomeSections();
  const requestedSectionIndex = Number(requestedSection);
  const renderedHomeSections = requestedSection == null
    ? homeSections
    : Number.isInteger(requestedSectionIndex) && requestedSectionIndex > 0
      ? homeSections.slice(requestedSectionIndex - 1, requestedSectionIndex)
      : [];

  useEffect(() => {
    if (!renderedHomeSections.length) return;

    if (sectionObserverRef.current) {
      sectionObserverRef.current.disconnect();
      sectionObserverRef.current = null;
    }

    sectionObserverRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const sectionKey = entry.target?.getAttribute("data-section-key");
          if (!sectionKey || observedSectionsRef.current.has(sectionKey)) return;

          const section = renderedHomeSections.find((s) => s._sectionKey === sectionKey);
          if (!section) return;

          observedSectionsRef.current.add(sectionKey);
          trackEvent("view_item_list", {
            page_type: "home_page",
            client_code: gaTrackingConfig.trackingContext.client_code,
            platform_code: gaTrackingConfig.trackingContext.platform_code,
            ecommerce: {
              items: section._visibleProducts.map((product, itemIndex) => ({
                index: itemIndex + 1,
                item_id: product?.sku || product?.id,
                item_name: product?.name || "",
                item_brand: product?.name || "",
                item_category: "Giftcards",
                item_category2: product?.clientCategoryName || "",
                affiliation: gaTrackingConfig.trackingContext.affiliation,
                item_list_name: section?.sectionName || "",
                item_list_id:
                  section?.sectionName || "",
                item_image: getImageUrl(product?.small) || defaultImage,
                item_url: getItemUrl(product),
              })),
            },
          });
        });
      },
      { threshold: 0.4 }
    );

    // Only observe sections that have visible products
    renderedHomeSections.forEach((section) => {
      if (section._visibleProducts?.length > 0) {
        const node = sectionElementsRef.current[section._sectionKey];
        if (node) {
          sectionObserverRef.current.observe(node);
        }
      }
    });

    return () => {
      if (sectionObserverRef.current) {
        sectionObserverRef.current.disconnect();
      }
    };
  }, [renderedHomeSections, categoryAllData]);


  const handleClick = (selectedItem, section, itemIndex) => {
    const itemListName = section?.sectionName || "";
    // const itemListId = section?.id?.toString() || itemListName;
    const selectedIndex = Number(itemIndex) + 1;
    sessionStorage.removeItem("ga4_item_list_name");
    sessionStorage.removeItem("ga4_seletedProductIndex");
    sessionStorage.setItem("ga4_item_list_name", itemListName);
    sessionStorage.setItem("ga4_seletedProductIndex", selectedIndex);
    trackEvent("select_item", {

      page_url: window.location.href,
      page_type: "home_page",
      client_code: gaTrackingConfig.trackingContext.client_code,
      platform_code: gaTrackingConfig.trackingContext.platform_code,
      ecommerce: {
        items: [
          {
            item_id: selectedItem?.sku,
            item_name: selectedItem?.name,
            item_brand: selectedItem?.name,
            item_category: 'Giftcards',
            item_category2: getCategoryName(selectedItem),
            affiliation: gaTrackingConfig.trackingContext.affiliation,
            item_list_name: sessionStorage.getItem("ga4_item_list_name") || "",
            item_list_id: sessionStorage.getItem("ga4_item_list_name") || "",
            item_image: getImageUrl(selectedItem?.small),
            item_url: selectedItem?.url ? selectedItem.url : "NA",
            index: parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) || null,
          }]
      }
    });
    dispatch(setProduct(selectedItem));
    // Conditionally encrypt the productId parameter based on environment setting
    const productId = selectedItem?.id.toString();
    const finalProductId =
      process.env.REACT_APP_IS_E_E === "false"
        ? productId
        : encryptURLParam(productId);
    navigate(`/giftcard?productId=${finalProductId}`);
  };

  // const [notFoundStates, setNotFoundStates] = useState([]);

  // const handleImageError = (index, productIndex) => {
  //   setNotFoundStates((prevState) => ({
  //     ...prevState,
  //     [`${index}-${productIndex}`]: true,
  //   }));
  // };

  const imageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop if fallback fails
    e.target.src = defaultImage; // Set fallback
  };

  const getMaxPrice = (priceDenominations) => {
    if (priceDenominations) {
      const pricesArray = priceDenominations?.split(",");
      const pricesNumbers = pricesArray?.map(Number);
      return Math.max(...pricesNumbers);
    }
  };
  const getMinPrice = (priceDenominations) => {
    if (priceDenominations) {
      const pricesArray = priceDenominations?.split(",");
      const pricesNumbers = pricesArray?.map(Number);
      return Math.min(...pricesNumbers);
    }
  };

  const calculatePoints = (index, item) => {
    const productId = item.id;
    const maxPrice = getMaxPrice(item?.priceDenominations);
    const minPrice = getMinPrice(item?.priceDenominations);
    const discountEntry = addSpecialData[index]?.products?.find(
      (entry) => entry.id === productId
    );
    if (discountEntry) {
      if (discountEntry.minEarnPoints > 0) {
        return `${Math.round(
          (discountEntry.minEarnPoints / minPrice) *
          (maxPrice - (maxPrice * discountEntry.customerDiscount) / 100)
        )} ${translation?.points}`;
      }
    }
    return null;
  };

  const checkcalculatePoints = (index, item) => {
    const productId = item.id;
    const discountEntry = addSpecialData[index]?.products?.find(
      (entry) => entry.id === productId
    );
    if (discountEntry) {
      if (discountEntry.minEarnPoints > 0) {
        return true;
      }
    }
    return null;
  };
  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview"
  )?.configValue;

  return (
    <>
      <ScrollToTop />
      {renderedHomeSections.some(s => s?._visibleProducts?.length > 0) && (
        <div className="mainDiv giftcard_list_section">
          {renderedHomeSections.map((item, index) => {
            const showMoreAfter = Number(item?.showMoreGiftCard)
              ? Number(item?.showMoreGiftCard)
              : 11;
            const validProducts = item?._validProducts?.filter((p) =>
              p?.clientProductDenomination?.some((d) => d?.enabled === true)
            );
            const visibleProducts = item?._visibleProducts?.filter((p) =>
              p?.clientProductDenomination?.some((d) => d?.enabled === true)
            );

            return (
              visibleProducts.length > 0 && (
                <div
                  className="container"
                  key={item?._sectionKey}
                  data-section-key={item?._sectionKey}
                  ref={(node) => {
                    if (node) {
                      sectionElementsRef.current[item?._sectionKey] = node;
                    }
                  }}
                >
                  {item?.products?.length > 0 && (
                    <div className="special-section-header mtb">
                      <h5 className="sec-below-head">{item?.sectionName}</h5>
                      {item?.subtitle && (
                        <p className="sec-below-subtitle">{item.subtitle}</p>
                      )}
                    </div>
                  )}

                  <div className="trending_card_box_main">
                    {visibleProducts.map((items, productIndex) => {
                      const denominationConfigs = Array.isArray(items?.clientProductDenomination)
                        ? items.clientProductDenomination
                        : [];

                      const baseDenomination = getRewardBaseDenomination({
                        product: items,
                        eligibleDenominations: denominationConfigs,
                        fallbackDenominations: denominationConfigs,
                      });
                      const enabledDenominations = denominationConfigs.filter(
                        (denomination) => denomination?.enabled === true
                      );
                      const displayAmount = enabledDenominations.length > 0 ? enabledDenominations[0].denomination : 0;
                      const isPercentage = String(clientConfigReducer?.earnPointDisplayType || "").toLowerCase() === "percentage";
                      const earnDisplayType = isPercentage ? EARNING_DISPLAY_TYPE.PERCENTAGE : EARNING_DISPLAY_TYPE.VALUE;
                      const earning = calculateEarning({
                        amount: displayAmount,
                        minEarnPoints: items?.minEarnPoints,
                        minBurnPoints: items?.maxEarnPoints,
                        baseDenomination,
                        displayType: earnDisplayType,
                        discountPercentage: items?.customerDiscount,
                      });

                      return (
                        <div
                          className="trending_card_box"
                          key={productIndex}
                        >


                          <img
                            className="w-100 i-rd"
                            src={getImageUrl(items?.small)}
                            alt={items?.name}
                            onError={imageError}
                            onClick={() => handleClick(items, item, productIndex)}
                          />
                          {/* <div className="earn-label-text"> {items?.name} </div> */}
                          {items?.customerDiscount !== 0 && (
                            <div className={isDiscountShowLabelConfig ? "discountOff2 " : "d-none"}>
                              {items?.customerDiscount}% {translation?.off}
                            </div>
                          )}
                          {isEarnLabelConfig && earning?.displayValue > 0 &&

                            <div className="product-list-earn-label">
                              <span className="earnDisplayHome"> {translation?.earn}{" "}</span>
                              <span>
                                {earning.displayValue.toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                })}
                                {isPercentage ? "%" : ` ${translation?.pts}`}
                                {" "} {translation?.earnBonusRewardPoints}
                              </span>
                              <img src={pointIcon} alt="" aria-hidden="true" className="point_icon" />{" "}
                            </div>
                          }
                        </div>
                      );
                    })}

                    {validProducts.length > showMoreAfter && (
                      <div className="trending_card_box show_more_box">
                        <div className="w-100 i-rd d-flex flex-column align-items-center justify-content-center text-center  trending_show_more"
                          onClick={() => {
                            trackEvent("link_click", {
                              title: `${translation?.more} ${translation?.eGiftCards}`,
                              page_url: "/productlist?trending=true",
                              section_title: item?.sectionName,
                            });

                            const trendingValue = "true";
                            const specialIdValue = item?.id.toString();

                            const finalTrending =
                              process.env.REACT_APP_IS_E_E ===
                                "false"
                                ? trendingValue
                                : encryptURLParam(trendingValue);

                            const finalSpecialId =
                              process.env.REACT_APP_IS_E_E ===
                                "false"
                                ? specialIdValue
                                : encryptURLParam(specialIdValue);
                            navigate(
                              `/productlist?trending=${finalTrending}&specialId=${finalSpecialId}`,
                              {
                                state: {
                                  isTrending: true,
                                  productData: item?.products,
                                  name: item?.sectionName,
                                },
                              }
                            );
                          }}
                        >
                          <div className="text-center mt-2 more_text_box">
                            <span className="upto">{translation?.more}</span>
                            <p className="poin">{translation?.eGiftCards}</p>
                          </div>
                          <div className="arrow_show">
                            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.71165 12.8864L5.22869 11.4162L9.12145 7.52344H0V5.36293H9.12145L5.22869 1.47656L6.71165 1.19209e-06L13.1548 6.44318L6.71165 12.8864Z" fill="#3C3C3C" />
                            </svg>
                          </div>
                        </div>
                        <div className="upto upto_more_text">{translation?.more}</div>
                      </div>
                    )}
                  </div>
                </div>
              )
            );
          })}
        </div>
      )}
    </>
  );
};

export default TrendingGiftCards;
